import elementTypes from 'generics/components/basic-text-editor-slate/elements/types';

export function isDivisionIdentitySelected(sender, user) {

  return sender.value !== user.emailIdentity.fromEmailAddress;

}

export function applyStartupMemberEmailAddresses(memberMap, contacts) {

  for (let contact of contacts) {

    const startupUserId = contact.startupUserId;
    const member = memberMap[startupUserId];

    if (member === void 0) {
      continue;
    }

    contact.value = member.emailIdentity.fromEmailAddress;

  }

}

export function getInboxMessageEditorDisabledElements() {

  const elements = [
    elementTypes.SINGLE_PRODUCER_MEETING,
    elementTypes.IMAGE, elementTypes.BUTTON,
    elementTypes.POLL_EDITOR_VIEW,
    elementTypes.TOGGLE_LIST_ITEM
  ];

  return elements;

}

export function getChatMessageEditorEnabledElements() {

  return [
    elementTypes.DEFAULT,
    elementTypes.HT_FILE,
    elementTypes.BLOCK_QUOTE,
    elementTypes.HEADING_ONE,
    elementTypes.HEADING_TWO,
    elementTypes.HEADING_THREE,
    elementTypes.HEADING_FOUR,
    elementTypes.HEADING_FIVE,
    elementTypes.HEADING_SIX,
    elementTypes.LINK,
    elementTypes.LIST_ITEM,
    elementTypes.BULLETED_LIST,
    elementTypes.NUMBERED_LIST,
    elementTypes.BULLETED_LIST_ITEM,
    elementTypes.NUMBERED_LIST_ITEM,
    elementTypes.CHECK_LIST_ITEM
  ];

}